import { useState, useEffect } from "react";
import {
  verifyOtpAndSetProxy,
  APIGateway } from
"../../../services/rhapsody/ManageDependents";
import { config } from "../../../utils/constants";
import { Loader } from "../../../common/Loader";
import { getMaskedMobileNo } from "../../../common/MaskedMobileNo";

const OtpVerification = ({
  setShowOtp,
  setAlertAddDependent,
  setCurrentPage,
  setDependentList,
  patientId,
  patientYear,
  emiratesId,
  emiratesYear,
  setAlertAlreadyAdded,
  mobileNumber,
  id,
  setAlertDeceasedPatient,
  translationMap
}) => {
  const [alert, setAlert] = useState(false);
  const [timer, setTimer] = useState(300);
  const [isResendEnabled, setIsResendEnabled] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: ""
  });

  const [isBlocked, setIsBlocked] = useState(false);
  const [blockTimer, setBlockTimer] = useState(0);
  const [isContinueDisabled, setIsContinueDisabled] = useState(true);
  const [, setOtpEntered] = useState(0);
  const [isLoading, setIsLoading] = useState(false);


  useEffect(() => {
    if (blockTimer > 0) {
      const interval = setInterval(() => {
        setBlockTimer((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(interval);
    } else if (blockTimer === 0 && isBlocked) {
      setIsBlocked(false);
    }
  }, [blockTimer, isBlocked]);

  useEffect(() => {
    if (timer > 0) {
      const countdown = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else {
      setIsResendEnabled(true);
    }
  }, [timer]);

  const handleOtpChange = (e) => {
    setAlert(false);
    setOtpError("");
    const { id, value } = e.target;
    if (/^\d?$/.test(value)) {
      setOtp((prevOtp) => {
        const updatedOtp = { ...prevOtp, [id.split("-")[1]]: value };
        const allInputsCleared = Object.values(updatedOtp).every(
          (val) => val === ""
        );
        setIsContinueDisabled(allInputsCleared);
        return updatedOtp;
      });
      // Automatically move to the next input field
      if (value.length === 1 && e.target.nextElementSibling) {
        e.target.nextElementSibling.focus();
      }
    }
  };

  const handleResendCode = async () => {
    setOtpError("");
    if (isBlocked) {
      setOtpError(translationMap?.otpBlocked);
      return;
    }
    const year = patientId ? patientYear : emiratesYear;
    const patientInfo = await APIGateway(patientId, emiratesId, year);
    //console.log("handling resend otp", patientInfo);
    if (patientInfo) {
      setAlert(true);
      setIsResendEnabled(false);
      setTimer(300);
    }
  };

  const otpVerification = async () => {
    setAlert(false);
    setOtpError("");
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    setIsLoading(true);
    try {
      const result = await verifyOtpAndSetProxy(
        patientId,
        emiratesId,
        fullOtp,
        id
      );
      setOtp({ first: "", second: "", third: "", fourth: "" });
      if (result?.data?.success) {

        if (result?.data?.message === "Deceased") {
          setCurrentPage("home");
          window.parent.scrollTo(0, 0);
          setAlertAddDependent(false);
          setAlertAlreadyAdded(false);
          setAlertDeceasedPatient(true);
          return;
        } else
        if (result?.data?.message === "Already Exist") {
          setCurrentPage("home");
          window.parent.scrollTo(0, 0);
          setAlertDeceasedPatient(false);
          setAlertAddDependent(false);
          setAlertAlreadyAdded(true);
          return;
        }
        setDependentList(result.data.dependentList);
        setCurrentPage("home");
        setAlertAlreadyAdded(false);
        setAlertAddDependent(true);
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        if (error.response.data.error === "otpBlocked") {
          setIsBlocked(true);
          setBlockTimer(300);
          setOtpError(
            translationMap?.otpBlocked || "Your OTP has been blocked due to multiple failed attempts. Please try again after 5 minutes."
          );
        } else
        if (error.response.data.error === "otpExpired") {
          setOtpError(translationMap?.otpExpired);
        } else {
          setOtpError(translationMap?.invalidOtp);
        }
      } else {
        setOtpError(translationMap?.unexpectedError);
      }
      setOtpEntered((prevOtp) => prevOtp + 1);
      setOtp({ first: "", second: "", third: "", fourth: "" });
      // console.error("OTP verification error:", error);
    } finally
    {
      setIsLoading(false);
    }
  };

  const handleCloseModal = async () => {
    setShowOtp(false);
    window.parent.scrollTo(0, 0);
    const fullOtp = otp.first + otp.second + otp.third + otp.fourth;
    await verifyOtpAndSetProxy(
      patientId,
      emiratesId,
      fullOtp,
      id
    );
  };

  if (isLoading)
  {
    return (
      <Loader />);

  }

  return (
    <>
      <div
        className="modal Custom_Modal_Box show"
        id="mobilenumberverification"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
        style={{ display: "block" }}>
        
        <div className="modal-dialog CoveragePlan_Dialog2" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <div className="Title_Inner_Box">
                <h6 className="MainTitleOne">
                  {translationMap?.mobileNoVerification}
                </h6>
              </div>
            </div>
            {alert &&
            <div className="Alert_Main_Box">
                <div className="AlertInnerBox GreenAlertInnerBox alert alert-dismissible fade show">
                  <button
                  type="button"
                  className="close"
                  data-dismiss="alert"
                  onClick={() => setAlert(false)}>
                  
                    &times;
                  </button>
                  <div className="Icon_box">
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a>
                      <span className="material-symbols-outlined">
                        check_circle
                      </span>
                    </a>
                  </div>
                  <div className="alert_text">
                    <p className="number_txt">
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>{translationMap?.otpResendSuccessfully}</a>
                    </p>
                  </div>
                </div>
              </div>
            }
            <div className="modal-body">
              <div className="Manage_Dependent_Modal_Box3">
                <p className="para_txt">
                  {translationMap?.otpNoText}{" "}
                  <span style={{ direction: "ltr" }}>{config.uaeCountryCode}{" "}{getMaskedMobileNo(mobileNumber)}</span>
                </p>
                <div className="opt_main_box">
                  <p>{translationMap?.verificationCode}</p>
                  <div className="custom_row" style={{ direction: "ltr" }}>
                    {["first", "second", "third", "fourth"].map(
                      (digit, index) =>
                      <input
                        key={digit}
                        id={`otp-${digit}`}
                        type="number"
                        min="0"
                        max="9"
                        className={`input_number_verify ${
                        otpError ? "errorRedAlert" : ""}`
                        }
                        placeholder="0"
                        inputmode="numeric"
                        style={{ MozAppearance: "textfield" }}
                        value={otp[digit]}
                        onChange={handleOtpChange}
                        //oninput="if(this.value.length > 1) this.value = this.value.slice(0, 1);"
                        onKeyDown={(e) => {
                          if (
                          e.key === "Backspace" &&
                          !otp[digit] &&
                          index > 0)
                          {
                            document
                            .querySelectorAll(".input_number_verify")[
                            index - 1].focus();
                          }
                        }} />


                    )}
                  </div>
                  {otpError &&
                  <div className="verifyContent">
                    <p className="codeErrorAlert">{otpError}</p>
                  </div>
                  }
                  <p className="opt_timer_box">
                    {isBlocked ?
                    blockTimer > 0 &&
                    <span className="blockTimer">{`(${Math.floor(
                        blockTimer / 60
                      )}:${String(blockTimer % 60).padStart(
                        2,
                        "0"
                      )})`}</span> :

                    timer > 0 &&
                    <span className="optTimer">{`(${Math.floor(
                        timer / 60
                      )}:${String(timer % 60).padStart(2, "0")})`}</span>
                    }
                  </p>
                </div>
                <h6 className="Gray_Title">
                  {translationMap?.didNotGetCode}{" "}
                  {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                  <a
                    onClick={() => {
                      if (!isBlocked && isResendEnabled) {
                        handleResendCode();
                      }
                    }}
                    // disabled={!isResendEnabled}
                    style={{
                      color: !isBlocked && isResendEnabled ? "#3b4f63" : "gray",
                      cursor:
                      !isBlocked && isResendEnabled ?
                      "pointer" :
                      "not-allowed"
                    }}>
                    
                    {translationMap?.clickToResend || "click here to resend"}
                  </a>
                </h6>
              </div>
            </div>

            <div className="modal-footer modal_footer_btn_box2">
              <button
                type="button"
                className="btn bluetrans_btn_link"
                data-dismiss="modal"
                onClick={handleCloseModal}>
                
                {translationMap?.back}
              </button>
              <button
                type="button"
                className={`${
                isContinueDisabled || isBlocked ?
                "disabled_btn_link" :
                "btn blue_btn_link"}`
                }
                disabled={isContinueDisabled}
                onClick={otpVerification}
                // style={{
                //   cursor: isBlocked ? "not-allowed" : "pointer",
                // }}
              >
                {" "}
                {translationMap?.continue}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>);

};

export default OtpVerification;